import { data } from 'jquery';
import url, { get, post, del, put, getUrl, delUrl,blobs,getFormdata } from './http'

//get,post,del,put 默认json  getUrl,delUrl:url+/参数

// 基础公共接口
export const login = data => post('/login/login', data); //登录
export const loginOut = data => post('/v1/api/users/logout', data); //退出登录
// export const getDictInfo = data => getUrl('/dict/getDictInfo/' + data); //获取数字字典
export const getDictInfoNew = data => getUrl(`/v1/basicdata/getDictList?dictCode=${data}`); //新获取数字字典
export const getDictInfoNews = data => getUrl(`/v1/basicdata/getDictList?dictCode=${data}&isReadable=true`); //新获取数字字典
export const industryList = () => get('/v1/basicdata/getIndustryList'); //获取行业分类


//企业详细
// export const getAreaList = data => getUrl('/v1/basicdata/getAreaList/' + data); //查询地域信息   ?id=' + dat
export const getAreaList = data => get('/v1/basicdata/getAreaList?level='+data.level+'&parentCode='+data.parentCode); //获取地域信息（分级获取）

// http://192.168.2.248:50010/imspp_sys/v1/basicdata/getAreaList?level=3&parentCode=140400


export const getIndustryList = () => get('/v1/basicdata/getIndustryList'); //查询国民经济行业分类信息


export const getPublicKey = () => get('/api/v1/auth/getPublicKey'); //第三方跳转登录获取公钥




export const thirdPartyCheckVaild = data => post('/api/v1/auth/thirdPartyCheckVaild', data); //第三方校验登录合法性
export const thirdPartyIsOpen = data => post('/api/v1/auth/thirdPartyIsOpen', data); //第三方校验登录合法性







//系统管理 - 数字字典
export const selectDictPageList = data => post('/dict/selectDictPageList', data); //列表查询接口_根据条件分页查询字典主类别信息  qs.stringify(data)表单  formData
export const insertDict = data => post('/dict/insertDict', data); //新增数据字典主类别
export const deleteDictByIds = data => del('/dict/deleteDictByIds', data); //主_删除接口_根据IDS批量删除字典主类别  formData 增加 parames:{header:{content-type:application/x-www-form-urlencoded}}
export const updateDict = data => put('/dict/updateDict', data); //主_修改接口_根据ID修改字典主类别
export const selectDictDetailById = data => getUrl('/dict/selectDictDetailByDictId/' + data.ids); //明_查询接口_根据字典ID查询该字典明细信息s
export const insertDictDetail = data => post('/dict/insertDictDetail', data); //明-新增主类别下的明细字典(带枚举)
export const updateDictDetail = data => put('/dict/updateDictDetail', data); //明_修改主类别下的明细字典(带枚举)
export const deleteDictDetailByIds = data => del('/dict/deleteDictDetailByIds', data); //明-删除主类别下的明细字典(带枚举) 增加 parames:{header:{content-type:application/x-www-form-urlencoded}}

//系统管理 - 功能权限管理
// export const insertFunMenu = data => post('/funMenu/insertFunMenu', data); //增加功能菜单及功能菜单权限
// export const updateFunMenu = data => put('/funMenu/updateFunMenu', data); //修改功能菜单
// export const deleteFunMenu = data => delUrl('/funMenu/deleteFunMenu/' + data); //删除功能菜单
// export const selectFunMenuTree = () => get('/funMenu/selectFunMenuTree'); //查询功能菜单树uID
// export const selectFunMenuById = data => getUrl('/funMenu/selectFunMenuById/' + data); //根据功能菜单ID查询菜单及菜单权限信息(修改时获取详情)

// //系统管理 - 用户管理
// export const findUserPage = data => post('/user/findUserPage', data); //查询列表用户信息 qs.stringify(data)表单  formData
// export const insertUser = data => post('/user/insertUser', data); //新增用户
// export const updateUser = data => put('/user/updateUser', data); //修改用户信息
// export const deleteUser = data => del('/user/deleteUser', data); //删除用户信息
// export const updateUserStatusById = data => put('/user/updateUserStatusById', data); //修改用户状态
// export const updateUserPasswordById = data => put('/user/updateUserPasswordById', data); //修改用户密码

// //系统管理 - 角色管理
// // export const selectFunMenuTree = data => post('/funMenu/selectFunMenuTree',data); //查询功能树菜单
// export const findRolePage = data => post('/role/findRolePage', data); //查询列表角色信息 qs.stringify(data)表单  formData
// export const insertRole = data => post('/role/insertRole', data); //新增角色
// export const updateRole = data => put('/role/updateRole', data); //修改角色
// export const deleteRole = data => del('/role/deleteRoleById', data); //删除角色信息
// export const updateRoleStatusById = data => put('/role/updateRoleStatusById', data); //修改角色状态
// export const insertUserRole = data => post('/role/insertUserRole', data); //用户授权_增加接口_给角色授用户权限 qs.stringify(data)表单  formData   Content-Type：multipart/form-data
// export const selectRoleById = data => getUrl('/role/selectRoleById/' + data); //根据ID获取角色信息
// export const selectUserRoleByRoleId = data => getUrl('/role/selectUserRoleByRoleId/' + data); //用户权限_查询接口_根据角色ID查询该角色下授用户权限
// export const insertFunRole = data => post('/role/insertFunRole', data); //功能权限_增加接口_给角色授功能权限 qs.stringify(data)表单  formData
// export const selectFunAuthRoleByRoleId = data => getUrl('/role/selectFunAuthRoleByRoleId/' + data); //功能权限_查询接口_根据角色ID查询该角色功能授权信息
// export const deleteRoleById = data => delUrl('/role/deleteRoleById/' + data); //删除接口_取消用户授权
// export const findUserRoleByRoleidPage = data => post('/user/findUserRoleByRoleidPage', data); //查询接口_根据角色ID获取角色授权选择用户列表


// //系统管理 - 日志管理管理
// export const selectOperLogPageList = data => post('/operlog/selectOperLogPageList', data); //查询操作日志  qs.stringify(data)表单  formData
// export const selectOperLogById = data => getUrl('/operlog/selectOperLogById/' + data); //根据操作日志ID查询详细信息
// export const selectOperErrorLogPageList = data => post('/operlog/selectOperErrorLogPageList', data); // //查询异常日志  qs.stringify(data)表单  formData
// export const selectOperErrorLogById = data => getUrl('/operlog/selectOperErrorLogById/' + data); //根据异常日志ID查询日志详细信息
// export const operType = () => get('/operlog/getOperType'); //获取业务类型


// //系统管理 - 部门管理
// export const insertDept = data => post('/dept/insertDept', data); //增加部门信息
// export const updateDept = data => put('/dept/updateDept', data); //根据功能ID修改功部门
// export const deleteDept = data => del('/dept/deleteDept', data); //删除部门
// export const selectDeptTree = data => get('/dept/selectDeptTree', data); //获取单位树



export const checkRepeat = data => get('/v1/api/users/checkBind?value=' + data.value + '&type=' + data.type + '&idcradType=' + data.idcradType, data); //验证唯一性


// 公告管理

export const getqueryPageInfo = data => post('/notice/queryPageInfo', data); //公告列表，
export const getDetailById = data => getUrl('/notice/getDetailById?id=' + data); //根据id查询公告详情
export const getInsertNotice = data => post('/notice/insertNotice', data); //新增公告信息 multipart/form-data
export const getDeleteNotice = data => del('/notice/deleteNotice', data); //删除单个
export const getDeployNotice = data => post('/notice/deploy', data); //发布公告信息 
export const getImgPath = data => getUrl('/notice/getImg?path=' + data); //公告图片下载
export const getRevoke = data => post('/notice/revoke', data); //撤回已发布公告信息
export const getUpdateNotice = data => post('/notice/updateNotice', data); //修改公告信息

// export const getHomeNoticeList = () => get('/notice/getHomeNoticeList'); //官网获取公告信息集合
export const getHomeNoticeList = data => get('/notice/queryNoticeListByHome?pageSize=' + data.size + '&pageNum=' + data.page ,data); //官网获取公告信息集合






//人员资质企业门户

export const enterpriselogincode = () => get('/v1/api/users/code'); //获取验证码

export const registUser = data => post('/v1/api/users/regist', data); //注册登录接口


export const logins = data => post('/v1/api/users/login', data); //登录接口


export const evaluationDisplay = data => post('/questionnaireType/evaluationDisplay', data); //注册接口

export const updatePasswd = data => post('/v1/api/users/updatePwd', data); //修改密码

// 个人中心

export const userInfo = data => get(`/v1/api/personnelInfo/${data.id}/info`, data); // 获取个人信息
export const updatePersonInfo = data => post('/v1/api/personnelInfo/updatePersonInfo', data); // 更新信息
export const uploadAvatar = data => post('/v1/api/personnelInfo/avatar', data); // 更新照片
export const queryUpgradeList = data => post('/v1/api/qualificationsUpgrade/queryIndividualQualificationsUpgradeList', data); // 资质升级记录



// 资质升级
export const qualificationsUpgrade = data => post('/v1/api/qualificationsUpgrade', data); // 资质升级基本信息保存
export const qualificationsUpgradeFile = data => post('/v1/api/qualificationsUpgrade/saveQualificationsUpgradeFile', data); // 资质升级记录 附件
export const qualificationsDetail = data => get(`/v1/api/qualificationsUpgrade/${data.split('=')[1]}`, data); // 根据ID查询资质升级信息
export const queryExamCertificat = data => get(`/v1/api/examCertificate/queryExamCertificat?cerType=${data.split('=')[1]}`, data); // 根据资质类型查询资质信息
export const updateUpgrade = data => post('/v1/api/qualificationsUpgrade/updateQualificationsUpgrade', data); // 资质升级 -修改
export const delfile = data => del(`/v1/api/file/${data.split('=')[1]}`, data); // 根据ID查询资质升级信息
export const submitQualificationsUpgrade = data => get(`/v1/api/qualificationsUpgrade/submitQualificationsUpgrade/${data.split('=')[1]}`, data); // 根据ID查询资质升级信息
export const checkExistsQualificationsUpgradeInfo = data => get(`/v1/api/qualificationsUpgrade/checkExistsQualificationsUpgradeInfo?cerType=${data.split('=')[1]}`, data); // 根据ID查询资质升级信息
export const queryQualificationsUpgradeAuditRecord = data => get(`/v1/api/qualificationsUpgradeAudit/queryQualificationsUpgradeAuditRecord/${data.split('=')[1]}`, data); // 根据ID查询资质升级信息



// 删除个人信息照片
export const delAvatar = data => del(`/v1/api/personnelInfo/avatar/${data.split('=')[1]}`, data); // 更新照片


export const updatePersonUnit = data => post('/v1/api/personnelInfo/updatePersonUnit', data); // 更新工作信息
// 预览
export const fileInfo = data => get(`/v1/api/file/${data.split('=')[1]}/view`, data); //在线预览资质照片

// 获取地域
export const getAreaLists = data => get(`/v1/basicdata/getAreaList?level=${data.level}&parentCode=${data.parentCode}`, data) //获取地域-城市
// 获取行业
export const getIndustryListJob = data => get(`/v1/basicdata/getIndustryList`, data) //获取技术领域
// 查询资质
export const searchCertif = data => post(`/v1/api/examCertificate/queryExamCertificat`, data) //查询资质信息
// 获取资质信息中的分级评价服务项
export const getService = data => get(`/v1/api/examCertificate/qeuryExamCertificateServiceProject?cerCode=${data.split('=')[1]}`, data) //
// 校验采集截止日期
export const getAreaTime = data => post(`/v1/api/patentPerson/checkAcquisitionTime`, data) //检验采集截止日期


// 资质信息
export const getPersonCer = data => post(`/v1/api/personCer/pages`, data) //查询
// 新增
export const addPersonCer = data => post(`/v1/api/personCer/`, data) //新增
// 删除
export const delPersonCer = data => del(`/v1/api/personCer/del?id=${data.split('=')[1]}`, data) //新增


// 上传
export const uploadFile = data => post(`/v1/api/file`, data); // 上传文件

// 删除文件
export const delectFile = data => del(`/v1/api/file/${data.split('=')[1]}`, data); // 

// 忘记密码
export const checkIsRegist = data => get(`/v1/api/users/checkIsRegist/${data.split('=')[1]}`, data); //判断该电话号是否注册
export const sendSmsCaptcha = data => get(`/v1/api/users/sendSmsCaptcha/${data.split('code=')[1].split('&')[0]}/${data.split('exist=')[1]}`, data); //发送短信验证码
export const checkCaptcha = data => post(`/v1/api/users/checkCaptcha`, data); //校验验证码是否有效
export const resetPassword = data => post('/v1/api/users/resetPassword', data); //修改密码

// 资质申请-咨询师、游戏主持人
// 首页展示资质信息
export const homePages = (data,datas) => post(`/v1/api/examCertificate/${data.split('cerType=')[1]}/homePublicCertificatePages`, data);

// 查询资质 学习证明列表
export const studyList = (data) => get(`/v1/api/studyEvidence/querystudyEvidence/${data.split('type=')[1].split('&')[0]}?idcardNum=${data.split('idcardNum=')[1]}`, studyList);
// 个人中心-资质申请
export const practicePage = data => post(`/v1/api/aptitudeApply/pages`, data);
export const queryAuditList = data => get(`/v1/api/audit/queryAuditList/${data.split('=')[1]}`, data);

export const delCers = data => del(`/v1/api/aptitudeApply/${data.split('=')[1]}`, data);


// 申请资质前的资格校验
export const preCheck = data => get(`/v1/api/aptitudeApply/preCheck/${data.split('=')[1].split('&')[0]}/${data.split('cerType=')[1]}`, data);
// 新增资质申请人员信息
export const addAptitude = data => post(`/v1/api/aptitudeApply`, data); // 新增
export const aptitudeUpdata = data => post(`/v1/api/aptitudeApply/update`, data); //  修改
export const aptitudeDetail = data => get(`/v1/api/aptitudeApply/info/${data.split('=')[1]}`, data); // 查看
// 新增资质申请人员企业信息
export const addUnit = data => post('/v1/api/aptitudeApply/unit',data)
export const unitUpdata = data => post(`/v1/api/aptitudeApply/unit/update`, data); //  修改
export const unitDetail = data => get(`/v1/api/aptitudeApply/unit/info/${data.split('=')[1]}`, data); // 查看
export const unitDel = data => del(`/v1/api/aptitudeApply/unit/${data.split('=')[1]}`, data); // 删除
// 新增资质申请人员资质信息
export const addcertificate = data => post('/v1/api/aptitudeApply/certificate',data)
export const certificateUpdata = data => post(`/v1/api/aptitudeApply/certificate/update`, data); //  修改
export const certificateDetail = data => get(`/v1/api/aptitudeApply/certificate/info/${data.split('=')[1]}`, data); // 查看
// 提交申请
export const submitApply = data => get(`/v1/api/aptitudeApply/${data.split('=')[1]}/submitAnApplication`, data); // 查看


// 查询资质信息选择的选项
export const queryList = data => getFormdata('/v1/api/aptitudeApply/queryRelevantValidQualifications',data)





// http://localhost:8018/imspp_answersheet/evaluationResult/reportPreview

// {{question}}/questionNaire/getIssessQuestionNaireList?questionTypeId=63EBF7C9A677483CA57A516B8F49FE9B&questionNaireId=
// {{question}}/questionNaire/getQuestionBank?questionTypeId=63EBF7C9A677483CA57A516B8F49FE9B&questionNaireId=5A8F7F2DB58B45C9A43609D37AD23CB5
// http://192.168.2.248:20001/imspp_sys/enterprise/liaison/insertLiaison

// export const getQuestionBank = data => getUrl('/questionNaire/getQuestionBank?questionTypeId=' + data); //根据id获取问卷题库信息(包含已选题库信息)


// export const getQuestionNaireDetail = data => getUrl('/questionNaire/getQuestionDetailById?id=' + data); //根据问卷记录id获取题库详情